(function () {
  function init() {
    const summary = document.querySelector('[data-selection-summary]');
    if (!summary) return;

    const container = summary.closest('product-payment-container') || document;
    const addToCart = container.querySelector('[data-product-add-to-cart-button]');
    if (!addToCart) return;

    const colorTarget = summary.querySelector('[data-summary-color]');
    const shackleTarget = summary.querySelector('[data-summary-shackle]');
    const wristTarget = summary.querySelector('[data-summary-wrist]');

    let errorBox = summary.querySelector('.selection-error');
    if (!errorBox) {
      errorBox = document.createElement('div');
      errorBox.className = 'selection-error';
      errorBox.style.color = '#c00';
      errorBox.style.fontSize = '13px';
      errorBox.style.marginTop = '10px';
      errorBox.style.display = 'none';
      summary.appendChild(errorBox);
    }

    function formatList(arr) {
      if (arr.length === 1) return arr[0];
      if (arr.length === 2) return arr[0] + ' en ' + arr[1];
      return arr.slice(0, -1).join(', ') + ' en ' + arr[arr.length - 1];
    }

    function setButtonText(text) {
      if (addToCart.firstElementChild) {
        addToCart.firstElementChild.innerHTML = text;
      } else {
        addToCart.innerHTML = text;
      }
    }

    let hasAutoScrolledToCheckbox = false;

    function update() {
      const colorChecked = document.querySelector('input[name^="option"]:checked');
      const checkedImageChoice = document.querySelector('.image-choice__radio:checked');
      const wristField = document.querySelector('.product-form__wrist-size select, .product-form__wrist-size input');
      const wristConfirmation = document.querySelector('#wrist-measured-confirmation');

      const color = colorChecked ? colorChecked.value : '';
      const logoBead = checkedImageChoice ? checkedImageChoice.value : '';
      const wrist = wristField ? wristField.value : '';

      if (colorTarget) colorTarget.textContent = color || '-';
      if (shackleTarget) shackleTarget.textContent = logoBead || '-';
      if (wristTarget) wristTarget.textContent = wrist || '-';

      const isKralen = !colorTarget;
      const missing = [];

      if (!wrist) missing.push('Maat');

      if (wristConfirmation && !wristConfirmation.checked) {
        missing.push('bevestiging dat je strak hebt gemeten');
      }

      if (!isKralen && !color) missing.push('kleur');
      if (!logoBead) missing.push(isKralen ? 'logo bead' : 'sluiting');

      const onlyCheckboxMissing =
  wristConfirmation &&
  !wristConfirmation.checked &&
  wrist &&
  (isKralen || color) &&
  logoBead;

if (onlyCheckboxMissing && !hasAutoScrolledToCheckbox) {
  hasAutoScrolledToCheckbox = true;

  const checkboxLabel = wristConfirmation.closest('label');

  if (checkboxLabel) {
    checkboxLabel.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    checkboxLabel.style.outline = '2px solid #c00';
    checkboxLabel.style.outlineOffset = '6px';

    setTimeout(function () {
      checkboxLabel.style.outline = '';
      checkboxLabel.style.outlineOffset = '';
    }, 1800);
  }
}

if (!onlyCheckboxMissing) {
  hasAutoScrolledToCheckbox = false;
}

   if (missing.length > 0) {
        addToCart.setAttribute('disabled', 'disabled');
        addToCart.setAttribute('aria-disabled', 'true');
        addToCart.style.setProperty('cursor', 'not-allowed', 'important');
        addToCart.style.setProperty('background', 'transparent', 'important');
        addToCart.style.setProperty('color', '#000', 'important');
        addToCart.style.setProperty('border', '1px dashed #000', 'important');
        setButtonText('Maak keuze compleet');

        errorBox.style.display = 'block';
        errorBox.style.color = '#c00';
        errorBox.textContent = 'Selecteer eerst: ' + formatList(missing);
      } else {
  addToCart.removeAttribute('disabled');
  addToCart.removeAttribute('aria-disabled');
  addToCart.style.removeProperty('cursor');
  addToCart.style.removeProperty('background');
  addToCart.style.removeProperty('color');
  addToCart.style.removeProperty('border');
  setButtonText('Bestel armband');

  const parsedWrist = parseFloat((wrist || '').replace(',', '.'));

  if (
    wrist &&
    !isNaN(parsedWrist) &&
    (parsedWrist < 16 || parsedWrist > 21)
  ) {
    errorBox.style.display = 'block';
    errorBox.style.color = '#d97706';
    errorBox.textContent = 'Controleer je maat — de meeste klanten zitten tussen 17 en 20 cm.';
  } else {
    errorBox.style.display = 'none';
    errorBox.style.color = '#c00';
  }
}
    }

    document.addEventListener('change', update);
    document.addEventListener('input', update);

    addToCart.addEventListener('click', function () {
  const wristConfirmation = document.querySelector('#wrist-measured-confirmation');

  if (wristConfirmation && !wristConfirmation.checked) {
    const checkboxLabel = wristConfirmation.closest('label');

    if (checkboxLabel) {
      checkboxLabel.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      checkboxLabel.style.outline = '2px solid #c00';
      checkboxLabel.style.outlineOffset = '6px';

      setTimeout(function () {
        checkboxLabel.style.outline = '';
        checkboxLabel.style.outlineOffset = '';
      }, 1800);
    }
  }
});

  setInterval(update, 300);
  update();
  }

window.addEventListener('load', function () {
  setTimeout(init, 500);
});
})();

  